import Marquee from "react-fast-marquee";

export const EditorialMarquee = () => {
  return (
    <section aria-hidden className="py-10 md:py-16 border-y border-white/10 bg-oed-surface overflow-hidden">
      <Marquee speed={40} gradient={false} autoFill>
        {["Build Freedom", "Build Wealth", "Build Legacy"].map((t, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif-ed italic text-6xl md:text-8xl lg:text-9xl text-stroke px-8">
              {t}
            </span>
            <span className="text-oed-gold text-4xl md:text-6xl px-2">✦</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
};
